import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { getEnterpriseStationCodeFromUser } from '../enterprise-context';
import { LogicielCaisseAuthService } from './logiciel-caisse-auth.service';
import { LogicielCaisseModuleService } from './logiciel-caisse-module.service';

@Injectable({ providedIn: 'root' })
export class LogicielCaisseFrontLinkService {
  constructor(
    private readonly auth: LogicielCaisseAuthService,
    private readonly moduleService: LogicielCaisseModuleService
  ) {}

  frontBaseUrl(): string {
    const url =
      environment.logiciel_caisse_front_url ??
      (environment as { LOGICIEL_CAISSE_FRONT_URL?: string }).LOGICIEL_CAISSE_FRONT_URL ??
      'https://logiciel-caisse.agrosilo-solutions.com/';
    return String(url).replace(/\/$/, '');
  }

  private currentCodeStation(): string {
    const session = this.auth.getSession();
    if (session?.code_station) {
      return session.code_station;
    }
    try {
      const raw = localStorage.getItem('currentUser');
      if (!raw) {
        return '';
      }
      return getEnterpriseStationCodeFromUser(JSON.parse(raw));
    } catch {
      return '';
    }
  }

  canOpenFront(): boolean {
    const code = this.currentCodeStation();
    return !!code && this.moduleService.isEnabled(code) && this.auth.isAuthenticated();
  }

  buildConnectedFrontUrl(): string | null {
    const session = this.auth.getSession();
    if (!session?.token) {
      return null;
    }
    const payload = btoa(
      JSON.stringify({
        token: session.token,
        code_station: session.code_station,
        email: session.email,
        stationId: session.station_id_back ?? session.stationId,
        station_id_back: session.station_id_back ?? session.stationId,
        name: session.name,
      })
    );
    return `${this.frontBaseUrl()}/?lc_auth=${encodeURIComponent(payload)}`;
  }

  openConnectedFront(): void {
    const url = this.buildConnectedFrontUrl();
    if (!url) {
      return;
    }
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}
